export default __webpack_public_path__ + "images/wbtcIcon_ef8a2e.svg";